<template>
    <FilterExpandCollapse label="Race & ethnicity">
      <div v-for="item in races" :key="item.id">
        <hp5-semantic size-selection="xs">
          <div v-if="item.type === 'R'" class="selection">
            <input :id="`race-${item.id}`" type="checkbox" :value="item.id" v-model="filterContext.races" />
            <label :for="`race-${item.id}`">{{ item.description }}</label>
          </div>
          <div v-else class="selection">
            <input :id="`ethnicity-${item.id}`" type="checkbox" :value="item.id" v-model="filterContext.ethnicities" />
            <label :for="`ethnicity-${item.id}`">{{ item.description }}</label>
          </div>
        </hp5-semantic>
      </div>
    </FilterExpandCollapse>
</template>

<script setup>
      const { races, filterContext } = useFCPModel()
</script>
  
<style scoped lang="scss">
  .selection {
    display: flex;
    align-items: center;
  }
  label {
    padding-left: var(--spacing-xs);
  }
</style>